<template>
    <div class="wrapper wrapper-card">
        <banner
            :document="document"
            :model="model"
        />

        <sticky-mobile :document="document" />

        <div class="sticky-wrapper">
            <div class="sticky-wrapper__inner">
                <div class="container-left">
                    <sticky
                        :document="document"
                        :model="model"
                    />
                    <div class="text-compliance">
                        {{ model.complianceExample }}
                    </div>
                </div>

                <div class="container-right">
                    <CreditWarning v-if="$isSweden() && ! model.isDebit" />
                    <card-unavailable v-if="model.isArchived" :document="document" />

                    <info
                        :document="document"
                        :model="model"
                    />
                    
                    <div
                        class="rich-text"
                        v-html="$prismic.asHtml(document.data.review)"
                    />

                    <card-faq
                        :document="document"
                    />

                    <card-quote 
                        v-if="quoteEnabled"
                        :document="document" 
                    />

                    <compare
                        :document="document"
                        :model="model"
                    />

                    <reviews
                        :document="document"
                        :model="model"
                    />

                    <open-hours
                        :document="document"
                        :model="model"
                    />

                    <contact
                        :document="document"
                        :model="model"
                    />
                    
                    <script v-if="jsonld" type="application/ld+json" v-html="jsonld" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from './CardBanner.vue';
import Info from './CardData.vue';
import Reviews from './CardReviews.vue';
import OpenHours from './CardOpeningHours.vue';
import Contact from './CardContact.vue';
import Compare from './CardCompareCards.vue';
import Sticky from './CardSticky.vue';
import StickyMobile from './CardStickyMobile.vue';
import CardQuote from './CardQuote.vue';
import CardFaq from './CardFaq.vue';
import CreditWarning from '@/components/CreditWarning.vue';
import CardUnavailable from './CardUnavailable.vue';
export default {
    components: {
        Banner,
        StickyMobile,
        Info,
        Reviews,
        OpenHours,
        Contact,
        Compare,
        Sticky,
        CardQuote,
        CardFaq,
        CreditWarning,
        CardUnavailable
    },
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        model() {
            return new this.$models.CreditCard(this.document, this.$store);
        },
        jsonld() {
            if (
                !this.model._ratings 
                || !this.model._ratings.data
                || !this.model._ratings.data.length
            ) {
                return '';
            }

            return {
                '@context': 'https://schema.org',
                '@type': 'Product',
                'name': this.document.data.title,
                'dateModified': this.$format.date(this.document.last_publication_date),
                'aggregateRating': {
                    '@type': 'AggregateRating',
                    'ratingValue': this.model._ratings.average_score,
                    'ratingCount': this.model._ratings.count,
                    'reviewCount': this.model._ratings.count,
                    'worstRating': '1',
                    'bestRating': '5'
                }
            };
        },
        quoteEnabled() {
            return this.document.data.quote_header
                .filter(object => object.text && object.text.trim().length > 0)
                .length > 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper::v-deep {
    .sticky-wrapper {
        @include flex;
        padding: 40px 20px;

        @include device(desktop) { padding: 60px 20px; }

        &__inner {

            @include flex(center,start);
            width: 1200px;
            max-width: 100%;
            position: relative;

            @media screen and (max-width: 1000px) {}

            .container-left {

                @media screen and (max-width: 1000px) {
                    display: none;
                    max-width: 700px;
                }

                @media screen and (min-width: 1001px) {
                    width: 320px;
                    position: relative;
                    position: sticky;
                    top: 100px;
                    margin-top: -350px;
                }
                .text-compliance{
                    padding: 5px 10px;
                }
            }

            .container-right {
                @include flex;
                // background: $white;

                @media screen and (max-width: 1000px) {
                    width: 100%;
                    max-width: 700px;
                }

                @media screen and (min-width: 1001px) {
                    width: calc(100% - 320px);
                    padding-left: 40px;
                    box-sizing: border-box;
                }

                .preamble {
                    @include font-size(20px,12px);
                    @include device(mobile) {
                        @include font-size(16px,8px);
                    }
                }

                .grid-layout {
                    width: 100%;
                    margin-bottom: 60px;
                    @include grid(1,60px);
                    @include device(mobile) {
                        @include grid(1,30px);
                    }
                    .container { margin-bottom: 0px; }
                }

                .container {
                    width: 100%;
                    margin-bottom: 60px;
                    &:last-child { margin-bottom: 0; }

                    &.data {
                        @include border-radius(10px);
                        background: $graybg;
                        @include spacing(padding,6);

                        li {
                            @include flex(between);
                            width: 100%;
                            padding: 10px 0;
                            @include border(bottom);
                            @include device(mobile) {
                                @include font-size(14px);
                            }
                            // &:last-child { border-bottom: 0; }

                            span {
                                @include font-size(16px,8px);
                                @include device(mobile) {
                                    @include font-size(14px,8px);
                                }
                                &:first-child {
                                    font-weight: bold;
                                    padding-right: 10px;
                                }
                                &:last-child { 
                                    flex: 1;
                                    text-align: right!important; 
                                }

                                i { font-size: 17px; }
                            }

                            .standard-yearly-cost {
                                color: red;
                                margin-left: 5px;
                                text-decoration: line-through;
                            }
                        }

                        .info-text {
                            font-style: italic;
                            margin-top: 25px;
                            display: block;
                            font-size: 13px;
                            opacity: .5;
                        }
                    }
                }

                h3 { @include spacing(margin,4,bottom); }

                .rich-text { margin-bottom: 60px; }
            }
        }
    }
}
.credit-warning {
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f2f2f2; 
}
</style>
